import { render } from "./BudgetPrevisions.vue?vue&type=template&id=5b6fc75b&ts=true"
import script from "./BudgetPrevisions.vue?vue&type=script&lang=ts"
export * from "./BudgetPrevisions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__